export const HelpCenterUrls = {
  HELP_CENTER: 'https://us.scoot.app/knowledge-base',
  SCREEN_SHARE_ERROR: 'https://us.scoot.app/knowledge-base',
  PREPARE_NETWORK: 'https://us.scoot.app/knowledge-base',
  ENABLE_CAMERA_AND_MIC: 'https://us.scoot.app/knowledge-base',
  SCOOT_SCREEN_SHARE_ERROR: 'https://us.scoot.app/knowledge-base',
  SCOOT_PREPARE_NETWORK: 'https://us.scoot.app/knowledge-base',
  SCOOT_ENABLE_CAMERA_AND_MIC: 'https://us.scoot.app/knowledge-base',
  SMART_BADGING: 'https://us.scoot.app/knowledge-base',
  HARDWARE_ACCELERATION: 'https://us.scoot.app/knowledge-base',
};
